'use client';

import { GoogleTagManager } from '@next/third-parties/google';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export function GtmManager() {
  const pathname = usePathname();
  const isKlaviyoFormPage = pathname === '/klaviyo-form';

  // Initialize dataLayer and configure GTM for SPA tracking
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    // Configure GTM for SPA tracking
    window.dataLayer.push({
      'gtm.allowlist': ['google', 'jsm'],
      'gtm.blocklist': ['customScripts'],
    });

    // Override History API to ensure GTM detects changes
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function (...args) {
      originalPushState.apply(history, args);
      // Trigger GTM history change detection
      window.dispatchEvent(new PopStateEvent('popstate'));
    };

    history.replaceState = function (...args) {
      originalReplaceState.apply(history, args);
      // Trigger GTM history change detection
      window.dispatchEvent(new PopStateEvent('popstate'));
    };

    return () => {
      // Cleanup: restore original methods
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);

  // Track page views on route changes
  useEffect(() => {
    // Skip tracking for klaviyo form pages
    if (isKlaviyoFormPage) return;

    // Send comprehensive page view event to GTM on route change
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'gtm.historyChange-v2', // Use the expected GTM event name
      'gtm.historyChangeSource': 'pushState',
      page_path: pathname,
      page_title: document.title,
      page_location: window.location.href,
      page_referrer: document.referrer,
    });
  }, [pathname, isKlaviyoFormPage]);

  if (isKlaviyoFormPage) {
    return null;
  }

  return <GoogleTagManager gtmId="GTM-TSG6CH22" />;
}
